import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UpdateAlert from './components/UpdateAlert';
import Notices from 'flarum/forum/components/Notices';
export default function addUpdateAlert() {
  extend(Notices.prototype, 'items', function (items) {
    var _app$session$user;
    if ((_app$session$user = app.session.user) != null && _app$session$user.fofTermsPoliciesHasUpdate()) {
      items.add('updateAlert', m(UpdateAlert, null), 1001);
    }
  });
}